import React from "react";
import LoaderFullScreen from "../../shared_lib/custom/loader/loaderFullscreen/LoaderFullScreen";

const LoaderFullScreenApp = () => {
  return <LoaderFullScreen />;
};
export default LoaderFullScreenApp;
